import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Brand } from "../components/Layout";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Register() {
  const { t } = useI18n();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#0F172A] text-white p-12 hero-grid-bg">
        <Brand light />
        <div>
          <h2 className="font-heading text-3xl font-bold leading-tight">{t("hero.title")}</h2>
          <p className="mt-4 text-slate-300">{t("value.prop")}</p>
        </div>
        <span className="text-xs text-slate-500">© {new Date().getFullYear()} RamenHersteller.be</span>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
          <div className="lg:hidden mb-8"><Brand /></div>
          <h1 className="font-heading text-2xl font-bold text-slate-900">{t("auth.register")}</h1>
          {error && <p className="mt-4 rounded-lg bg-red-50 border border-red-200 p-3 text-sm text-red-700" data-testid="register-error">{error}</p>}
          <div className="mt-6 space-y-4">
            <div><Label>{t("auth.name")}</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="register-name" className="mt-1" /></div>
            <div><Label>{t("auth.email")}</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="register-email" className="mt-1" /></div>
            <div><Label>{t("auth.phone")}</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="register-phone" className="mt-1" /></div>
            <div><Label>{t("auth.password")}</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={6} data-testid="register-password" className="mt-1" /></div>
          </div>
          <Button type="submit" className="cta-orange w-full rounded-full mt-6 py-6" disabled={loading} data-testid="register-submit">
            {loading ? <Loader2 className="animate-spin" /> : t("auth.registerbtn")}
          </Button>
          <p className="mt-4 text-sm text-slate-500 text-center">
            {t("auth.hasaccount")} <Link to="/login" className="text-brand-orange font-semibold" data-testid="goto-login">{t("auth.login")}</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
